import React from 'react';
import { MapPinIcon } from 'lucide-react';

/**
 * Franja de localización entre el Hero y la barra de confianza.
 * Funciona como transición de color (marfil → azul → blanco) y señal de ubicación.
 */
export function LocationStrip() {
  return <div className="flex h-11 w-full items-center justify-center bg-primary px-5" data-id="element-161" data-mp="3hvi4z77g53o0">
      <p className="flex items-center gap-2 font-sans text-[13px] font-medium text-white/85 lg:text-[14px]" data-id="element-162" data-mp="3mtaa52x3qma5">
        <MapPinIcon className="h-4 w-4 shrink-0 text-secondary" strokeWidth={1.8} data-id="element-163" data-mp="edqkedvn3lzu" />
        Atención presencial en Bogotá · Colombia
      </p>
    </div>;
}